import React from 'react';
import { fmtReceiptDate, payLabel } from '@/lib/eposPrint';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const PosReceipt = ({ receipt, withStyle = true }) => {
  if (!receipt) return null;
  const { order, store } = receipt;
  const cur = receipt.currency ? `${receipt.currency} ` : '';
  const money = (n) => `${cur}${Number(n || 0).toFixed(2)}`;
  const logo = store?.logo_url ? (store.logo_url.startsWith('http') ? store.logo_url : BACKEND + store.logo_url) : null;
  const a = order.shipping_address || {};
  return (
    <>
      {withStyle && (
        <style>{`@media print { body * { visibility: hidden; } #pos-receipt, #pos-receipt * { visibility: visible; } #pos-receipt { position: absolute; left: 0; top: 0; width: ${store?.paper_width === '58' ? '58mm' : '80mm'}; font-family: monospace; color: #000; background: #fff; } }`}</style>
      )}
      <div id="pos-receipt" className="hidden print:block p-2 text-[11px] leading-tight">
        {logo && (
          <div className="text-center">
            <img src={logo} alt="" style={{ maxWidth: '60%', maxHeight: 64, margin: '0 auto 4px', filter: 'grayscale(100%)' }} />
          </div>
        )}
        <div className="text-center font-bold text-[14px]">{store?.name || receipt.company_name}</div>
        {store?.address && <div className="text-center">{store.address}</div>}
        {store?.phone && <div className="text-center">{store.phone}</div>}
        {store?.trn && <div className="text-center">TRN: {store.trn}</div>}
        {store?.receipt_header && <div className="text-center font-bold">{store.receipt_header}</div>}
        <div className="text-center mt-2">TOTAL</div>
        <div className="text-center font-bold text-[16px] mb-2">{money(order.total_amount)}</div>
        <div className="flex justify-between font-bold"><span>Items</span><span>Price</span></div>
        <div>--------------------------------</div>
        {order.items.map((i, idx) => {
          const line = Number(i.quantity) * Number(i.price);
          return (
            <div key={idx}>
              {Number(i.quantity) === 1 && !(i.discount > 0) ? (
                <div className="flex justify-between"><span>{i.name || i.sku}</span><span>{money(line)}</span></div>
              ) : (
                <>
                  <div>{i.name || i.sku}</div>
                  <div className="flex justify-between"><span>  {i.quantity} x {money(i.price)}</span><span>{money(line)}</span></div>
                  {i.discount > 0 && <div className="flex justify-between"><span>  Discount</span><span>-{money(i.discount)}</span></div>}
                </>
              )}
              {i.note && <div>  * {i.note}</div>}
            </div>
          );
        })}
        <div>--------------------------------</div>
        <div className="flex justify-between"><span>SUBTOTAL</span><span>{money(order.subtotal)}</span></div>
        {order.discount_amount > 0 && <div className="flex justify-between"><span>CART DISCOUNT</span><span>-{money(order.discount_amount)}</span></div>}
        <div className="flex justify-between font-bold text-[13px]"><span>TOTAL</span><span>{money(order.total_amount)}</span></div>
        <div>--------------------------------</div>
        {(order.pos?.payments || []).map((p, idx) => (
          <div key={idx} className="flex justify-between"><span>{payLabel(p)}{p.reference ? ` (${p.reference})` : ''}</span><span>{money(p.amount)}</span></div>
        ))}
        {order.pos?.change_given > 0 && <div className="flex justify-between font-bold"><span>Change due</span><span>{money(order.pos.change_given)}</span></div>}
        <div>--------------------------------</div>
        {order.shopify_order_name && <div>Order: {order.shopify_order_name}</div>}
        {a.address1 ? (
          <div>
            <div className="font-bold">Ship to:</div>
            {(a.first_name || a.last_name) && <div>{`${a.first_name || ''} ${a.last_name || ''}`.trim()}</div>}
            <div>{a.address1}</div>
            {a.address2 && <div>{a.address2}</div>}
            {[a.city, a.province, a.zip].filter(Boolean).length > 0 && <div>{[a.city, a.province, a.zip].filter(Boolean).join(', ')}</div>}
            {a.country && <div>{a.country}</div>}
            {a.phone && <div>{a.phone}</div>}
          </div>
        ) : (
          store?.show_customer_on_receipt !== false && order.customer_name !== 'Walk-in Customer' && <div>Customer: {order.customer_name}</div>
        )}
        <div>--------------------------------</div>
        <div className="text-center">{fmtReceiptDate(order.created_at)}</div>
        <div className="text-center">Staff at register: {order.pos?.staff_name}</div>
        <div className="text-center">Receipt: {order.order_number}</div>
        {store?.receipt_footer && <div className="text-center">{store.receipt_footer}</div>}
      </div>
    </>
  );
};
